<div class="row dash" [@routerTransition]>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form background-card-primary3">
    <div class="card-body padding-all-0px margin-left-zero">
      <div>
        <div class="">
          <div class="row" *ngIf="ShowSkillsList">

            <div class="col-md-12 padding-right">
              <div *ngIf='IsShowActorFormList'>
                <div class="card skillassest">
                  <div class="card-header wh-header">
                    My Skills
                   
                  </div>
                  <div class="card-body search-body">
                    <div class="row">
                      <div class="card col-md-5 card-border margin-right-8 " *ngFor="let l of CurrentFdActorReportsDocController">
                        <div class="card-header  card-header2 padding-bottom">
                          <div class="row">
                            <div class="col-md-9">
                              <div class="badge contracts-badge4">{{l.templatename}}</div>  
                            </div>
                            <div class="col-md-1 padding-lr-0px col-md-margin">
                              <a class="" (click)="edit_(l.actorreportcode)" title="edit"><i class="fas fa-pencil-alt  nav-link-hand float-right "></i></a>

                            </div>
                            <div class="col-md-1 padding-lr-0px col-md-margin">

                              <a (click)="del_(l.actorreportcode)" title="remove"><i class="far fa-trash-alt  nav-link-hand float-right navlink-hand2"></i></a>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9 float-left attribute4">
                              <label class="label-specialty-11">{{l.specialty}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="card-body bar-char2 ">
                   

                          <div class="row margin-left-zero margin-right row-background">
                            <label class="margin-bottom-0px label-last "> last modified: {{l.date | date:'dd-mmm-yyyy'}}</label>
                        </div>




                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 padding-left-zero  row-background "hidden>
              <div class="card actor-card">
                <div class="card-header wh-header background-2 row-background ">Catalogue</div>
                <div class="card-body padding-all-0px margin-left-zero row-background ">
                  <div class="padding-left-21">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                  
                  <div class="table-component actor-table">

                    <div class="table-responsive padding-right-11px">


                      <table class="table table-striped margin-left-24px">
                        <tbody>
                          <tr *ngFor="let l of pdata">
                            <td class="td-padding2 ">

                              <div class="row margin-left-zero margin-right border4 margin-top-3px">
                                <div class="col-md-1  margin-tb-auto padding-lr-2px">
                                  <button type="button"
                                          (click)="ConfirmAndProceedToAddSkill(l)"
                                          class="btn  btn-sm driver-button " id="FileUpload"
                                          name="upload">
                                    <i class="fas fa-plus font-size-11"></i>
                                  </button>
                                </div>
                                <div class="col-md-11 margin-tb-auto padding-left-11px">
                                  <label class="margin-bottom-0px color3">{{l.DisplayName}}</label>
                                  <label class="">{{l.Specialty}}</label>
                                </div>
                              </div>


                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="row" *ngIf="ShowQuestionnaire">
         
            <div class="col-md-12">

              <div class="card skillassest">
                <div class="card-header wh-header">
                   Update Patient Vitals
                  <div class="row float-right">
                    <div class="col-md-4 padding-right padding-l-0px margin-right-16px">
                      <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3 margin-right-12px">Cancel</button>

                    </div>
                    <div class="col-md-4 padding-l-0px padding-right-0px">
                      <div *ngIf="CurrentFdActorDocReportDetailsController">
                        <div *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && IsRateing">
                          <button type="submit" class="btn actions-btn-prime margin-left-zero" (click)="SaveFDActorDocReportDetails()" *ngIf='!isRequesting'>Save</button>
                          </div>
                        </div>
                        </div>
                    <div class="col-md-2 padding-l-0px padding-right-0px">

                      <div *ngIf="CurrentFdActorDocReportDetailsController">
                        <div *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && IsRateing">
                          
                        </div>
                      </div>
                    
                    </div>
                      </div>
                      
                     

                    </div>
                <div class="card-body search-body  padding-left-0px padding-right-0px">
                

                  <div class="card-content" *ngIf="ActorReportCode >0 && IsRateing">
                    <div class="row">
                      <div class="offset-md-3 col-md-6 col-sm-12">
                        <div class="table-responsive">
                          <div class="rTable">
                            <div *ngIf="SelectedQA">
                              <div *ngFor="let group of SelectedQA; let gin = index">
                                

                                <div *ngIf="group.Questions.length >0" class="heading-pinkbg padding-all-0px font-size-14px font-weight-bold">{{group.Title}}</div>
                               
                                <div class="rTableRow qa-grid-wrapper dispaly3" *ngFor="let c of group.Questions; let i = index" [ngSwitch]="c.ValueType">
                                  <div class="_rTableCell font-size-14px margin-tb-auto">{{c.AttributeName}}</div>
                                  <div class="_rTableCell-right " *ngSwitchCase="'CsvList'">
                                    <div class="form-check form-check-inline" *ngFor="let cc of c.ValueSource | splitpipe:','">
                                      <label class="form-check-label font-size-14px">
                                        <input class="form-check-input radio-input-right" type="radio" value="{{cc}}" name="{{gin}}{{i}}"
                                               [(ngModel)]="c.ValueData"
                                               placeholder="Value" checked="checked">  {{cc}}
                                        <i class="input-helper"></i>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="_rTableCell-right " *ngSwitchCase="'Text'">
                                    <div class="form-check form-check-inline"
                                         >
                                      <label class="form-check-label font-size-14px">{{c.AttributeName}}</label>
                                        <input class="form-check-input radio-input-right"
                                               type="text" value="{{c.ValueData}}" name="{{gin}}{{i}}"
                                               [(ngModel)]="c.ValueData"
                                               placeholder="Value" checked="checked" />  
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                           
                          </div>
                         
                        
                        </div>
                      </div>
                    </div>
                  
                  
                  </div>
                </div>

                <div *ngIf="CurrentFdActorDocReportDetailsController">
                  <div class="card-content" *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && !IsRateing">
                    <h1> Template is Not Supporting</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
